import { userManagementActions } from "../../constants/actionTypes";

const INITIAL_STATE = {
  userManagementUploadData: "",
  userList: {},
  allUserList: {},
  allUserListError: "",
  addUser: "",
  defaultRolesData: [],
  assignRolesData: [],
  businessRolesData: [],
  editUser: {},
  updateUser: "",
  deletUserData: "",
  userActionData: {},
  userInfo: "",
  userError: "",
  userListLoading: false,
  userListPaginated: {},
  userManagementUploadError: "",
  activeUserReportLoading: false,
  activeUserReportData: [],
  activeUserReportSuccess: false,
};

const userManagement = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case userManagementActions.userManagementUploadSuccess:
      return {
        ...state,
        userManagementUploadData: action.data,
        userManagementUploadError: "",
      };

    case userManagementActions.userManagementUploadError:
      return {
        ...state,
        userManagementUploadError: action.data,
      };

    case userManagementActions.userListResetDataPaginated:
      return {
        ...state,
        userListPaginated: {},
      };

    case userManagementActions.userListSetData:
      return {
        ...state,
        userList: {
          ...action.payload,
        },
        allUserList: {},
      };

    case userManagementActions.allUserListSetData:
      return {
        ...state,
        allUserList: {
          ...action.payload,
        },
      };

    case userManagementActions.allUserListSetError:
      return {
        ...state,
        allUserListError: {
          ...action.payload,
        },
      };

    case userManagementActions.userListSetDataPaginated:
      const old_res = state.userListPaginated.results || [];
      const new_res = action?.payload?.results || [];
      return {
        ...state,
        userListPaginated: {
          ...state.userListPaginated,
          results: [...old_res, ...new_res],
        },
      };
    case userManagementActions.defaultRolesSuccess:
      return {
        ...state,
        defaultRolesData: action.data,
      };
    case userManagementActions.assignRolesSuccess:
      return {
        ...state,
        assignRolesData: action.data,
      };
    case userManagementActions.businessUnitSuccess:
      return {
        ...state,
        businessRolesData: action?.data?.data ? action?.data?.data : [],
      };
    case userManagementActions.userManagementCreateUserSuccess:
      return {
        ...state,
        addUser: action.data,
      };
    case userManagementActions.userManagementEditUserSuccess:
      return {
        ...state,
        editUser: {
          ...action.data,
        },
      };
    case userManagementActions.userManagementUpdateUserSuccess:
      return {
        ...state,
        updateUser: action.data,
      };
    case userManagementActions.USER_MNGMNT_DELETE_USER_SUCCESS:
      return {
        ...state,
        deletUserData: action.data,
      };
    case userManagementActions.userActionDataSuccess:
      return {
        ...state,
        userActionData: action.data,
      };
    case userManagementActions.setUserDetail:
      return {
        ...state,
        userInfo: action.payload,
      };
    case userManagementActions.REMOVE_SELECTED_USER_DETAILS:
      return {
        ...state,
        userInfo: "",
      };
    case userManagementActions.ERROR_CREATE_USER:
    case userManagementActions.userManagementEditUserError:
    case userManagementActions.userManagementUpdateUserError:
      return {
        ...state,
        userError: action?.data,
      };
    case userManagementActions.userListSetLoading:
      return {
        ...state,
        userListLoading: action?.payload,
      };

    //  Active Users Download Report
    case userManagementActions.ACTIVE_USER_DOWNLOAD_ACTION:
      return {
        ...state,
        activeUserReportLoading: true,
      };
    case userManagementActions.ACTIVE_USER_DOWNLOAD_SUCCESS:
      return {
        ...state,
        activeUserReportLoading: false,
        activeUserReportSuccess: true,
        activeUserReportData: action?.payload || [],
      };
    case userManagementActions.ACTIVE_USER_DOWNLOAD_ERROR:
      return {
        ...state,
        activeUserReportLoading: false,
        activeUserReportSuccess: false,
      };
    case userManagementActions.ACTIVE_USER_DOWNLOAD_RESET:
      return {
        ...state,
        activeUserReportLoading: false,
        activeUserReportSuccess: false,
        activeUserReportData: [],
      };

    default:
      return state;
  }
};

export default userManagement;
